import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RadioButton } from 'primereact/radiobutton';
import { Button, TextAreaField, CheckboxField } from "../../../helpers";
import { validateInputs } from '../../../utils';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';
import { CancelBuyerInvoiceSchem } from '../../../validation/cancelBuyerInvoiceValidation';

const CancelBuyerInvoiceModal = (props) => {
  const [reason, setReason] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const [checkboxValue, setCheckboxValue] = useState(false);
  const dispatch = useDispatch()

  const { handleCancelBuyerInvoice, cancelRemarks, setCancelRemarks } = props

  const handleRadioChange = (event) => {
    setReason(event.value);
    setCancelRemarks(event.value)

    if (event.value === 'Other') {
      setCancelRemarks('')
    }
  };

  const handleOtherReasonChange = (event) => {
    setOtherReason(event.target.value);
    setCancelRemarks(event.target.value)
  };

  const handleCheckboxChange = () => {
    setCheckboxValue(!checkboxValue);
  };

  const handleCancelInvoice = async () => {
    const cancelObj = {
      cancelRemarks : cancelRemarks
    }
    const validationRes = await validateInputs(CancelBuyerInvoiceSchem, cancelObj)

    if (validationRes.error) {
      if(validationRes.error.cancelRemarks){
          dispatch(raiseToast({severity:'error', detail: validationRes.error.cancelRemarks, life: 3000}))
      }
    }else{
        handleCancelBuyerInvoice()
    }
  };

  return (
    <div className='flex flex-column'>
      <div className='flex flex-row'>
        <p>Select Reason for Cancel Invoice<span style={{color:"red"}}>*</span></p>
      </div>

      <div className='flex flex-row'>
        <RadioButton inputId="duplicate" name="reason" value="Duplicate" onChange={handleRadioChange} checked={reason === 'Duplicate'}  required/>
        <label htmlFor="duplicate" className="p-radiobutton-label">Duplicate</label>
      </div>

      <div className='flex flex-row'>
        <RadioButton inputId="dataEntryMistake" name="reason" value="Data entry mistake" onChange={handleRadioChange} checked={reason === 'Data entry mistake'} />
        <label htmlFor="dataEntryMistake" className="p-radiobutton-label">Data entry mistake</label>
      </div>

      <div className='flex flex-row'>
        <RadioButton inputId="orderCancelled" name="reason" value="Order Cancelled" onChange={handleRadioChange} checked={reason === 'Order Cancelled'} />
        <label htmlFor="orderCancelled" className="p-radiobutton-label">Order Cancelled</label>
      </div>

      <div className='flex flex-row'>
        <RadioButton inputId="other" name="reason" value="Other" onChange={handleRadioChange} checked={reason === 'Other'} />
        <label htmlFor="other" className="p-radiobutton-label">Other</label>
      </div>

      {reason === 'Other' && (
        <div>
          <label style={{fontSize: '12px', marginBottom: '3px'}} className='flex flex-row mt-1 mb-1' htmlFor="otherReason">Other Reason:<span style={{color:"red"}}>*</span></label>
          <TextAreaField
            id="otherReason"
            value={otherReason}
            onChange={handleOtherReasonChange}
            rows={4}
            cols={30}
            required
          />
        </div>
      )}
      {/*<div style={{ position: 'absolute', bottom: 140, width: '100%', textAlign: 'center', marginBottom: '10px' }} className='flex flex-row justify-content-center align-center mt-2 mb-2'>
        <CheckboxField id='confirmationCheckbox' onChange={handleCheckboxChange} checked={checkboxValue} label='Refill Open PO Product Quantity.' />
      </div>*/}

      <div className='flex flex-row justify-content-center mt-5'>
        <Button label='CANCEL INVOICE' onClick={handleCancelInvoice} />
      </div>

    </div>
  );
};

export default CancelBuyerInvoiceModal;
